export const PROPERTY_INSTANCE = Object.freeze({
    DEFAULT_NAME: 'Property Instance',
});
export const SIZE_UNIT_MAPING = {
    'square feet': 'sqft',
    'acres': 'acres',
};

export const MILESTONES_DATA_ACCURACY_DISCLAIMER =
    'The information presented herein is provided as is, without warranty of any kind. ' +
    'Milestones Labs LLC does not assume any liability for errors or omissions.';

export const ACRES = {
    FULL: 43560,
    HALF: 21780,
    QUARTER: 10890,
};

export const PROPERTY_SEARCH_ACTIONS = {
    FAVORITE: 'favorite',
    SAVE_SEARCH: 'save-search',
    ATTACH_FILES: 'attach-files',
    CHAT: 'chat',
    TOUR: 'tour',
    OFFER: 'offer',
    FINANCE: 'finance',
    TRADE: 'trade',
    IM_THE_OWNER: 'im-the-owner',
};

export const SEARCH_TABS = {
    MAP: 'Map',
    LIST: 'List'
};